import service from '@/store/services/workshop/gate_pass-service';

const state = {
  list: {},
  gate_pass: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => { 
    state.list = list;
  },
  SET_RESOURCE: (state, gate_pass) => {
    state.gate_pass = gate_pass;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((gate_pass) => { commit('SET_RESOURCE', gate_pass); });
  },


  add({commit, dispatch}, params) {
    return service.add(params)
      .then((gate_pass) => { commit('SET_RESOURCE', gate_pass); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((gate_pass) => { commit('SET_RESOURCE', gate_pass); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  gate_pass: state => state.gate_pass,
  page: state => state.meta.page,
};
 
const gate_pass = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default gate_pass;
